import api from '@/services/api'

export const getReportsAuthorized = async () => {
  // 返回 { authorized: boolean }
  return api.get('/analytics/analytics/authorized/')
}

export const getReports = async (params = {}) => {
  // period: day|week|month, store_id, start, end
  return api.get('/analytics/analytics/reports/', { params })
}